import React from 'react';
import { Typography } from 'antd';
import Marquee from 'react-fast-marquee';
import '../assets/styles/Footer.css'; // Reuse the same CSS file

const { Title } = Typography;

// Partner logos and links
const partners = [
  { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg', url: 'https://www.microsoft.com' },
  { name: 'Google', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg', url: 'https://www.google.com' },
  { name: 'IBM', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg', url: 'https://www.ibm.com' },
  { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg', url: 'https://aws.amazon.com' },
  { name: 'NVIDIA', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Nvidia_logo.svg', url: 'https://www.nvidia.com' },
  { name: 'OpenAI', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg', url: 'https://openai.com' },
  { name: 'Meta', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ab/Meta-Logo.png', url: 'https://about.meta.com' },
  { name: 'Intel', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Intel-logo.svg', url: 'https://www.intel.com' },
  { name: 'Oracle', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg', url: 'https://www.oracle.com' },
  { name: 'SAP', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg', url: 'https://www.sap.com' },
];

const PartnerComponent = () => (
  <div className="partner-log">
    <Title level={5} className="partner-title">
      Partners Supporting AI & Innovation
    </Title>
    <Marquee gradient={false} pauseOnHover speed={50}>
      {partners.map((partner, index) => (
        <a
          key={index}
          href={partner.url}
          target="_blank"
          rel="noopener noreferrer"
          className="partner-item"
        >
          <img src={partner.logo} alt={partner.name} className="partner-logo" />
        </a>
      ))}
    </Marquee>
  </div>
);

export default PartnerComponent;